<template>
  <div id="login">
    <div class="preloader-wrapper big active">
      <div class="spinner-layer spinner-pink-only">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div>
      </div>
    </div>
    <div>ログイン中...</div>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";
import materialize from "materialize-css";
import cookie from "js-cookie";

export default {
  name: "Login",
  mounted: function() {
    this.login();
  },
  methods: {
    login: function() {
      // RSP チャットでのログアウト済み判定を削除
      cookie.remove("rsp_logouted");

      const self = this;
      fetch(process.env.VUE_APP_API_URL + "/api/rspchat/customtoken", {
        credentials: "include",
        method: "GET",
        mode: "cors",
        headers: {
          Authorization:
            "Basic " + process.env.VUE_APP_SAMPLE_STORE_API_BASIC_IPASS,
          "Content-Type": "application/json"
        }
      })
        .then(function(response) {
          if (response.status !== 200) {
            self.failToLogin();
            return;
          }
          response
            .json()
            .then(function(data) {
              firebase
                .auth()
                .signInWithCustomToken(data["custom_token"])
                .then(function() {
                  self.succeedToLogin();
                })
                .catch(function() {
                  self.failToLogin();
                  return;
                });
            })
            .catch(function() {
              self.failToLogin();
            });
        })
        .catch(function() {
          self.failToLogin();
        });
    },
    succeedToLogin: function() {
      // RSP チャットでのログイン失敗判定を削除
      cookie.remove("rsp_fail_to_login");

      this.$router.push({
        name: "Room",
        params: {
          room_id: this.$route.query.redirectRoomId
        }
      });
    },
    failToLogin: function() {
      // RSP チャットでのログイン失敗判定
      cookie.set("rsp_fail_to_login", true);

      materialize.toast({
        html: "ログインに失敗しました",
        displayLength: 1000
      });
      this.$router.push({
        name: "Room",
        params: {
          room_id: this.$route.query.redirectRoomId
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#login {
  margin: 0;
  position: absolute;
  top: 45%;
  width: 100%;
  text-align: center;
}
</style>
